import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/tenants/')({
	beforeLoad: () => {
		throw redirect({ to: '/tenants/current' })
	},
})
